const titleMap = {
    "/dashboard": "Dashboard",
    "/ForgotPassword": "Forget Password",
    "/reset-password": "Reset Password",
    "/notifications": "Notifications",
    "/profile": "Profile",
    "/users": "Users",
    "/users/create": "Users Creation",
    "/users/edit/:id": "Edit User",
    "/employeeTopup": "Employee Top Up",
    "/employeeTypes": "Employee Types",
    "/employeeTypes/create": "Employee Types Creation",
    "/employeeTypes/edit/:id": "Edit Employee Types",
    "/employees": "Employee",
    "/employees/create": "Employee Creation",
    "/employees/edit/:id": "Edit Employee",
    "/machines": "Machines",
    "/machines/edit/:id": "Edit Machines",
    "/machines/:machineId/slots/:slotNumber": "Edit Slot",
    "/machines/:machineId/boards/:boardId/slots/:slotId": "Edit Board",
    "/products": "Products",
    "/products/create": "Products Creation",
    "/products/edit/:id": "Edit Products",
    "/categories": "Categories",
    "/categories/create": "Categories Creation",
    "/categories/edit/:id": "Edit Categories",
    "/mro-transactions": "MRO Transactions",
    "/mro-transactions-by-product": "MRO Transactions By Product",
    "/mro-transactions-by-employee": "MRO Transactions By Employee",
    "/transactions": "Sales Transactions",
};

export default titleMap;